export default "__VITE_ASSET__ad118f20__"